import React, { useState } from 'react';
import { Collapse, Spin } from 'antd';
import { TableSecProps } from './props';
import { EstoqueDetalhesService } from '../../services/estoqueServices';
import { RowLine, SpanBlock } from './styles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import ModalSolicitarRetorno from '../Modal/ModalSolicitarRetorno';

const CardSecMobile: React.FC<TableSecProps> = ({ inscricaoEstadual, codProduto }) => {
  const { Panel } = Collapse;
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const filtro = useSelector((state: ApplicationState) => state.Estoque.filter);

  const handleClick = async () => {
    setLoading(true);
    try {
      await EstoqueDetalhesService.getDetalheEstoque(
        inscricaoEstadual,
        cddAtivo?.codCdd,
        codProduto,
        filtro
      ).then((res) => {
        setResponse(res.data.estoques);
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const resulta = response?.map((itemEstoq: any) => ({
    ...itemEstoq,
    diasParaVencer:
      itemEstoq.diasParaVencer < 0
        ? `${0} Dias`
        : itemEstoq.diasParaVencer
        ? itemEstoq.diasParaVencer + ' Dias'
        : '',
    qtdPadraoFracionado:
      itemEstoq.qtdPadraoFracionado === undefined ? 0 : itemEstoq.qtdPadraoFracionado,
  }));

  return (
    <Collapse onChange={handleClick} key={codProduto}>
      <Panel header="Detalhes" key={codProduto}>
        {loading ? (
          <Spin size="small" />
        ) : (
          resulta.map((item: any, index: any) => {
            return (
              <>
                <p style={{ textAlign: 'center' }}>
                  <ModalSolicitarRetorno
                    text={'Modal'}
                    record={item}
                    key={index}
                    detalhesEstoque={item.qtdPadraoFracionado === 0 ? 1 : item.qtdPadraoFracionado}
                    lote={item.controle}
                  />
                </p>
                <RowLine>
                  <p>
                    <strong>Número da nota </strong>
                    <SpanBlock> {item.nuNota}</SpanBlock>
                  </p>
                  <p>
                    <strong>Lote </strong>
                    <SpanBlock> {item.controle}</SpanBlock>
                  </p>
                  <p>
                    <strong>Tempo restante </strong>
                    <SpanBlock> {item.diasParaVencer}</SpanBlock>
                  </p>
                  <p>
                    <strong>Data validade </strong>
                    <SpanBlock> {item.dtValidade}</SpanBlock>
                  </p>
                </RowLine>

                <p>
                  <strong>Pagador </strong>
                  <SpanBlock>
                    {item.pagador == null ? 'PAGADOR NÃO IDENTIFICADO' : item.pagador}
                  </SpanBlock>
                </p>
                <RowLine>
                  <p>
                    <strong>Coberto </strong>
                    <SpanBlock> {item.cobertura ? 'Sim' : 'Não'}</SpanBlock>
                  </p>
                </RowLine>
                <RowLine>
                  <p>
                    <strong>Disponível</strong>
                    <SpanBlock>{item.disponivel}</SpanBlock>
                  </p>
                  <p>
                    <strong>Reservado </strong>
                    <SpanBlock style={{ color: item.reservado > 0 ? '#D48806' : '#595959' }}>
                      {item.reservado}
                    </SpanBlock>
                  </p>
                  <p>
                    <strong>Indisponível</strong>
                    <SpanBlock style={{ color: item.indisponivel > 0 ? '#CF1322' : '#595959' }}>
                      {item.indisponivel}
                    </SpanBlock>
                  </p>
                  <p>
                    <strong>Total </strong>
                    <SpanBlock> {item.total}</SpanBlock>
                  </p>
                </RowLine>
                <hr />
              </>
            );
          })
        )}
        {loading ? (
          ''
        ) : (
          <>
            <RowLine>
              <p>
                <SpanBlock>
                  <strong>SUBTOTAL</strong>
                </SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Disponível</strong>
                <SpanBlock>
                  {response.reduce((acc: any, item: any) => {
                    return acc + item.disponivel;
                  }, 0)}
                </SpanBlock>
              </p>
              <p>
                <strong>Reservado </strong>
                <SpanBlock>
                  {response.reduce((acc: any, item: any) => {
                    return acc + item.reservado;
                  }, 0)}
                </SpanBlock>
              </p>
              <p>
                <strong>Indisponível</strong>
                <SpanBlock>
                  {response.reduce((acc: any, item: any) => {
                    return acc + item.indisponivel;
                  }, 0)}
                </SpanBlock>
              </p>
              <p>
                <strong>Total </strong>
                <SpanBlock>
                  {response.reduce((acc: any, item: any) => {
                    return acc + item.total;
                  }, 0)}
                </SpanBlock>
              </p>
            </RowLine>
          </>
        )}
      </Panel>
    </Collapse>
  );
};

export default CardSecMobile;
